import React from "react";
import './ReadMore.scss'

const ReadMore = ({ text='', maxLength = 100, isExpanded, onToggle }) => {
  const collapseText = `${(text || '').slice(0, maxLength)}...`;

  return (
    <div className="jrf-readmore-container">
        {!isExpanded && collapseText.length && (
            <div>
                <div className="jrf-readmore-container__desc" dangerouslySetInnerHTML={{ __html: collapseText }} />
                <button
                    className="jrf-readmore-container__btn"
                    onClick={onToggle}
                >
                    Read more
                </button>
            </div>
        )}
    </div>
  );
};

export default ReadMore;
